import { AbstractFormElement, ICustomFormElement } from "./Abstract";

import { InputText } from "./Input";

class Time extends InputText implements ICustomFormElement {
    /**
     * initialize when added to dom
     */
    connectedCallback() {
        this.setAttribute("type", "time");
        super.connectedCallback();
    }
}

Time.prototype.shadowStyle = document.createElement("template");
Time.prototype.shadowStyle.innerHTML = `
${AbstractFormElement.prototype.shadowStyle.innerHTML}
<style>
input[type="time"]::-webkit-calendar-picker-indicator {
   background: none;
}
</style>
`;

Time.prototype.template = document.createElement("template");
Time.prototype.template.innerHTML = /*html*/ `
<label class="std-fe">
    <span class="label"><slot></slot></span>
    <span class="input"></span>
    <span class="icon time"></span>
</label>
<span class="error"></span>
<span class="help"></span>
`;

customElements.define("x-time", Time);
